/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {ThorServerDataParser} from "../ThorServerDataParser";
import {IThorGameData} from "./IThorServerData";
import {IThorParsedServerData} from "./IThorParsedServerData";
import {IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ThorGameMode} from "../../gamemode/ThorGameMode";

export class ThorParsedGameData extends SpinParsedGameData implements IThorParsedServerData {

    public static NUDGE_REWARDED_WILD_REELS_FEATURE:string = "Wild reels";
    public static NUDGE_REWARDED_RANDOM_WILDS:string = "Random Wilds";
    public static NUDGE_REWARDED_RANDOM_MULTIPLIER_FEATURE:string = "Random Multiplier";
    public static NUDGE_REWARDED_EXTRA_FS_SPINS:string = "Extra Spins";

    private _bonusSymbolPosition:number;
    private _collectedScattersBefore:number;
    private _collectedScattersAfter:number;
    private _nudgeFeatureRewarded:string;
    private _nudgeRespinTriggered:boolean;
    private _overlayWildsBeforeSpinStop:boolean[][];
    private _overlayWildsAfterSpinStop:boolean[][];
    private _payoutMultiplierBefore:number;
    private _payoutMultiplierAfter:number;
    private _scatterPositionsAfter:number[];
    private _scatterPositionsBefore:number[];
    private _scatterRespinTriggered:boolean;
    private _runeRazeTriggered:boolean;
    private _hammerTimeTriggered:boolean;
    private _runeRazeSymbol:string;
    private _landedScatterCountAfter:number;
    private _landedScatterCountBefore:number;
    private _meterSpinsCounterAfter:number;
    private _meterSpinsCounterBefore:number;
    private _totalSpinWinnings:string;
    private _totalSpinWinningsNonMultiplied:number;
    private _wildReelsAwardedThisSpin:boolean[];

    constructor(rawData:IThorGameData, dataParser:ThorServerDataParser) {
        super(rawData, dataParser);
        this._wildReelsAwardedThisSpin = rawData.wildReelsAwardedThisSpin;
        this._runeRazeTriggered = rawData.runeRazeTriggered;
        this._runeRazeSymbol = rawData.runeRazeSymbol;
        this._hammerTimeTriggered = rawData.hammerTimeTriggered;
        this._bonusSymbolPosition = rawData.bonusSymbolPosition;
        this._collectedScattersBefore = rawData.collectedScattersBefore;
        this._collectedScattersAfter = rawData.collectedScattersAfter;
        this._nudgeFeatureRewarded = rawData.nudgeFeatureRewarded;
        this._nudgeRespinTriggered = rawData.nudgeRespinTriggered;
        this._overlayWildsBeforeSpinStop = rawData.overlayWildsBeforeSpinStop;
        this._overlayWildsAfterSpinStop = rawData.overlayWildsAfterSpinStop;
        this._payoutMultiplierBefore = rawData.payoutMultiplierBefore;
        this._payoutMultiplierAfter = rawData.payoutMultiplierAfter;
        this._scatterPositionsAfter = rawData.scatterPositionsAfter;
        this._scatterPositionsBefore = rawData.scatterPositionsBefore;
        this._scatterRespinTriggered = rawData.scatterRespinTriggered;
        this._landedScatterCountAfter = rawData.landedScatterCountAfter;
        this._landedScatterCountBefore = rawData.landedScatterCountBefore;
        this._meterSpinsCounterAfter = rawData.meterSpinsCounterAfter;
        this._meterSpinsCounterBefore = rawData.meterSpinsCounterBefore;
        this._totalSpinWinnings = rawData.totalSpinWinnings;
        this._totalSpinWinningsNonMultiplied = rawData.totalSpinWinningsNonMultiplied;
    }

    protected isRespin(rawData:IServerData):boolean {
        return this.mode === GameMode.RESPIN || this.mode == ThorGameMode.NUDGE_RESPIN;
    }

    protected isNextRespin(rawData:IServerData):boolean {
        return this.nextMode === GameMode.RESPIN || this.nextMode == ThorGameMode.NUDGE_RESPIN;
    }


    protected isFreespin(rawData:IServerData):boolean {
        return super.isFreespin(rawData) || this.mode == ThorGameMode.NUDGE_RESPIN_FS;
    }

    protected isNextFreespin(rawData:IServerData):boolean {
        return super.isNextFreespin(rawData) || this.nextMode == ThorGameMode.NUDGE_RESPIN_FS;
    }

    get totalSpinWinnings():number {
        return Number(this._totalSpinWinnings);
    }

    get totalSpinWinningsNonMultiplied():number {
        return this._totalSpinWinningsNonMultiplied;
    }

    get bonusSymbolPosition():number {
        return this._bonusSymbolPosition;
    }

    get collectedScattersBefore():number {
        return this._collectedScattersBefore;
    }

    get collectedScattersAfter():number {
        return this._collectedScattersAfter;
    }

    get nudgeFeatureRewarded():string {
        return this._nudgeFeatureRewarded;
    }

    get nudgeRespinTriggered():boolean {
        return this._nudgeRespinTriggered;
    }

    get overlayWildsBeforeSpinStop():boolean[][] {
        return this._overlayWildsBeforeSpinStop;
    }

    get overlayWildsAfterSpinStop():boolean[][] {
        return this._overlayWildsAfterSpinStop;
    }

    get payoutMultiplierBefore():number {
        return this._payoutMultiplierBefore;
    }

    get payoutMultiplierAfter():number {
        return this._payoutMultiplierAfter;
    }

    get scatterPositionsAfter():number[] {
        return this._scatterPositionsAfter;
    }

    get scatterPositionsBefore():number[] {
        return this._scatterPositionsBefore;
    }

    get scatterRespinTriggered():boolean {
        return this._scatterRespinTriggered;
    }

    get runeRazeTriggered():boolean {
        return this._runeRazeTriggered;
    }

    get hammerTimeTriggered():boolean {
        return this._hammerTimeTriggered;
    }

    get runeRazeSymbol():string {
        return this._runeRazeSymbol;
    }

    get wildReelsAwardedThisSpin():boolean[] {
        return this._wildReelsAwardedThisSpin;
    }

    get landedScatterCountAfter():number {
        return this._landedScatterCountAfter;
    }

    get landedScatterCountBefore():number {
        return this._landedScatterCountBefore;
    }

    get meterSpinsCounterAfter():number {
        return this._meterSpinsCounterAfter;
    }

    get meterSpinsCounterBefore():number {
        return this._meterSpinsCounterBefore;
    }
}